<template>
    <div class="sort-container">
        <p class="total">検索結果{{ totalSpace }}件</p>
        <select class="sort cursor-pointer" @change="Sort" v-model="dataSort">
            <option class="select-option" 
            :value="item.label" 
            v-for="(item, index) in sortType" 
            :key="index" 
            :selected="dataSort == item.label"
            >
                {{ item.value }}
            </option>
        </select>
    </div>
</template>
<script setup>
import { ref, defineEmits, defineProps, watch } from "vue";
import { useRoute } from "vue-router";

const route = useRoute();
const emit = defineEmits(['handleSort', 'emitHandleSort'])
const props = defineProps({
    totalSpace: {
        type: Number
    },
})
const dataSort = ref(route.query.ss ?? "");
const totalSpace = ref(props.totalSpace ?? 0);

watch(props, ()=>{
    totalSpace.value = props.totalSpace
});

const sortType = ref([
  { label: "", value: "おすすめ順" },
  { label: "largeArea", value: "面積広い順" },
  { label: "narrowArea", value: "面積狭い順" },
  { label: "accommodatesManyPeople", value: "収容人数多い順" },
  { label: "accommodatesFewPeople", value: "収容人数少ない順" },
  { label: "walkFewMinutesStation", value: "駅から近い順" },
]);

watch(route, ()=>{
    dataSort.value = route.query?.ss ?? ""
})

const Sort = async (event) => {
    const selectSortValue = event.target.value;
    emit('handleSort', true, selectSortValue)
    emit('emitHandleSort', true, selectSortValue)
    window.scrollTo({ top: 0, behavior: "smooth" });
};
</script>
<style lang="scss" scoped>
.sort-container {
    display: flex;
    width: 45%;
    justify-content: flex-end;
    align-items: center;

    @media only screen and (max-width: 768px) {
        width: 100%;
    }

    .total {
        padding-right: 10px;
        color: #000;
        font-size: 14px;
        font-weight: 500;
    }

    .sort {
        appearance: auto;
        color: #222;
        font-size: 14px;
        font-weight: 500;
        display: flex;
        height: 35px;
        padding: 0px 10px;
        align-items: center;
        gap: 5px;
        border-radius: 4px;
        background: #fff;
        box-shadow: 1px 0px 5px 0px rgba(0, 0, 0, 0.12);
    }
}
</style>
